import { Box, Typography, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";

const PopUp = ({ open, onClose, title, children }) => {
  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <Box className="ikaro-overlay" onClick={handleBackdropClick}>
      <Box className="ikaro-modal p-24" style={{ minWidth: 300 }}>
        {title && (
          <Typography variant="h6" gutterBottom>
            {title}
          </Typography>
        )}
        <Box className="mb-16">
          {children}
        </Box>
        <IconButton className="popup-close-btn" onClick={onClose}>
          <Close />
        </IconButton>
      </Box>
    </Box>
  );
};

export default PopUp;
